var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMotionGraphics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,66.75A30.78457,30.78457,0,0,0,70.75,36h-1.5a29.25,29.25,0,0,1-58.5,0H9.25A30.78457,30.78457,0,0,0,40,66.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.75,24A8.75,8.75,0,1,0,56,32.75,8.75967,8.75967,0,0,0,64.75,24ZM56,31.25A7.25,7.25,0,1,1,63.25,24,7.258,7.258,0,0,1,56,31.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40,51.25v1.5A16.76884,16.76884,0,0,0,56.75,36h-1.5A15.2672,15.2672,0,0,1,40,51.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMotionGraphics);
export default __webpack_public_path__ + "static/media/icon_motion_graphics.4aff19f3270ecf4c0c4b80b6e66e8c4f.svg";
export { ForwardRef as ReactComponent };